import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FinancialService {
  constructor(private http: HttpClient) {}

  public balanceSheet(where: any = {}) {
    const path = 'api/reports/financial/balance-sheet';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    return this.http.get(path, { params: where });
  }

  public exportBalanceSheet(where: any = {}): Observable<Blob> {
    const path = 'api/reports/financial/balance-sheet';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    return this.http.get(path, { params: where, responseType: 'blob' });
  }

  public balanceSheetOld(where: any = {}) {
    const path = 'api/reports/financial/balance-sheet/old';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    return this.http.get(path, { params: where });
  }

  public exportBalanceSheetOld(where: any = {}): Observable<Blob> {
    const path = 'api/reports/financial/balance-sheet/old';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    where.export = 1;
    return this.http.get(path, { params: where, responseType: 'blob' });
  }

  public profitAndLoss(where: any = {}) {
    const path = 'api/reports/financial/pnl';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    return this.http.get(path, { params: where });
  }

  public exportProfitAndLoss(where: any = {}): Observable<Blob> {
    const path = 'api/reports/financial/pnl';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    where.export = 1;
    return this.http.get(path, { params: where, responseType: 'blob' });
  }

  public generalFundStatement(where: any = {}) {
    const path = 'api/reports/financial/gf-statement';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    return this.http.get(path, { params: where });
  }

  public exportGeneralFundStatement(where: any = {}): Observable<Blob> {
    const path = 'api/reports/financial/gf-statement';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    return this.http.get(path, { params: where, responseType: 'blob' });
  }

  public generalFundStatementCW(where: any = {}) {
    const path = 'api/reports/financial/gf-statement-cw';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    return this.http.get(path, { params: where });
  }

  public exportGeneralFundStatementCW(where: any = {}): Observable<Blob> {
    const path = 'api/reports/financial/gf-statement-cw';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    return this.http.get(path, { params: where, responseType: 'blob' });
  }

  public generalFundDistributionStatement(where: any = {}) {
    const path = 'api/reports/financial/gf-distribution-statement';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    return this.http.get(path, { params: where });
  }

  public exportGeneralFundDistributionStatement(where: any = {}): Observable<Blob> {
    const path = 'api/reports/financial/gf-distribution-statement';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    where.export = 1;
    return this.http.get(path, { params: where, responseType: 'blob' });
  }

  public generalFundExpenseDistributionStatement(where: any = {}) {
    const path = 'api/reports/financial/gf-expense-distribution-statement';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    return this.http.get(path, { params: where });
  }

  public exportGeneralFundExpenseDistributionStatement(where: any = {}): Observable<Blob> {
    const path = 'api/reports/financial/gf-expense-distribution-statement';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    where.export = 1;
    return this.http.get(path, { params: where, responseType: 'blob' });
  }

  public reservedFundStatement(where: any = {}) {
    const path = 'api/reports/financial/rf-statement';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    return this.http.get(path, { params: where });
  }

  public exportReservedFundStatement(where: any = {}): Observable<Blob> {
    const path = 'api/reports/financial/rf-statement';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    return this.http.get(path, { params: where, responseType: 'blob' });
  }

  public reservedFundStatementCW(where: any = {}) {
    const path = 'api/reports/financial/rf-statement-cw';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    return this.http.get(path, { params: where });
  }

  public exportReservedFundStatementCW(where: any = {}): Observable<Blob> {
    const path = 'api/reports/financial/rf-statement-cw';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    return this.http.get(path, { params: where, responseType: 'blob' });
  }

  public reservedFundDistributionStatement(where: any = {}) {
    const path = 'api/reports/financial/rf-distribution-statement';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    return this.http.get(path, { params: where });
  }

  public exportReservedFundDistributionStatement(where: any = {}): Observable<Blob> {
    const path = 'api/reports/financial/rf-distribution-statement';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    where.export = 1;
    return this.http.get(path, { params: where, responseType: 'blob' });
  }

  public reservedFundExpenseDistributionStatement(where: any = {}) {
    const path = 'api/reports/financial/rf-expense-distribution-statement';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    return this.http.get(path, { params: where });
  }

  public exportReservedFundExpenseDistributionStatement(where: any = {}): Observable<Blob> {
    const path = 'api/reports/financial/rf-expense-distribution-statement';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    where.export = 1;
    return this.http.get(path, { params: where, responseType: 'blob' });
  }

  public revenueExpenditureStatement(where: any = {}) {
    const path = 'api/reports/financial/revenue-expenditure-statement';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    return this.http.get(path, { params: where });
  }

  public exportRevenueExpenditureStatement(where: any = {}): Observable<Blob> {
    const path = 'api/reports/financial/revenue-expenditure-statement';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    return this.http.get(path, { params: where, responseType: 'blob' });
  }

  public revenueExpenditureStatementCW(where: any = {}) {
    const path = 'api/reports/financial/revenue-expenditure-statement-cw';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    return this.http.get(path, { params: where });
  }

  public exportRevenueExpenditureStatementCW(where: any = {}): Observable<Blob> {
    const path = 'api/reports/financial/revenue-expenditure-statement-cw';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    return this.http.get(path, { params: where, responseType: 'blob' });
  }

  public revenueExpenditureDistributionStatement(where: any = {}) {
    const path = 'api/reports/financial/revenue-expenditure-distribution-statement';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    return this.http.get(path, { params: where });
  }

  public exportRevenueExpenditureDistributionStatement(where: any = {}): Observable<Blob> {
    const path = 'api/reports/financial/revenue-expenditure-distribution-statement';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    where.export = 1;
    return this.http.get(path, { params: where, responseType: 'blob' });
  }

  public revenueExpenditureExpenseDistributionStatement(where: any = {}) {
    const path = 'api/reports/financial/revenue-expenditure-expense-distribution-statement';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    return this.http.get(path, { params: where });
  }

  public exportRevenueExpenditureExpenseDistributionStatement(where: any = {}): Observable<Blob> {
    const path = 'api/reports/financial/revenue-expenditure-expense-distribution-statement';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    where.export = 1;
    return this.http.get(path, { params: where, responseType: 'blob' });
  }

  public monthWiseRevenueExpenditureStatement(where: any = {}) {
    const path = 'api/reports/financial/month-wise-revenue-expenditure-statement';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    return this.http.get(path, { params: where });
  }

  public exportMonthWiseRevenueExpenditureStatement(where: any = {}): Observable<Blob> {
    const path = 'api/reports/financial/month-wise-revenue-expenditure-statement';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    return this.http.get(path, { params: where, responseType: 'blob' });
  }

  public budgetVsActuals(where: any = {}) {
    const path = 'api/reports/financial/budget-vs-actuals';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    return this.http.get(path, { params: where });
  }

  public exportBudgetVsActuals(where: any = {}): Observable<Blob> {
    const path = 'api/reports/financial/budget-vs-actuals';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    where.export = 1;
    return this.http.get(path, { params: where, responseType: 'blob' });
  }

  public exportLatestBudgetsVariance(where: any = {}): Observable<Blob> {
    const path = 'api/reports/financial/latest-budgets-variance';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    where.export = 1;
    return this.http.get(path, { params: where, responseType: 'blob' });
  }

  public budgetCommittments(where: any = {}) {
    const path = 'api/reports/financial/budget-committments';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    return this.http.get(path, { params: where });
  }

  public cashFlow(where: any = {}) {
    const path = 'api/reports/financial/cash-flow';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    return this.http.get(path, { params: where });
  }

  public trialBalance(where: any = {}, view: string = 'view1') {
    let path = 'api/reports/financial/trial-balance';
    if (view === 'view3') {
      path = 'api/reports/financial/closing-trial-balance';
    }
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    return this.http.get(path, { params: where });
  }

  public exportTrialBalance(where: any = {}, view: string = 'view1'): Observable<Blob> {
    let path = 'api/reports/financial/trial-balance';
    where.view = view;
    if (view === 'view3') {
      path = 'api/reports/financial/closing-trial-balance';
    }
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    return this.http.get(path, { params: where, responseType: 'blob' });
  }

  public delinquentOwners(where: any = {}) {
    const path = 'api/reports/financial/delinquent-owners';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    return this.http.get(path, { params: where });
  }

  public exportDelinquentOwners(where: any = {}): Observable<Blob> {
    const path = 'api/reports/financial/delinquent-owners';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    where.export = 1;
    return this.http.get(path, { params: where, responseType: 'blob' });
  }

  public delinquentCustomers(where: any = {}) {
    const path = 'api/reports/financial/delinquent-customers';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    return this.http.get(path, { params: where });
  }

  public exportDelinquentCustomers(where: any = {}): Observable<Blob> {
    const path = 'api/reports/financial/delinquent-customers';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    where.export = 1;
    return this.http.get(path, { params: where, responseType: 'blob' });
  }

  public accountsPayable(where: any = {}, view?: string) {
    let path = 'api/reports/financial/accounts-payable';
    if (view === 'vendor') {
      path = 'api/reports/financial/accounts-payable/by-vendors';
    }
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    return this.http.get(path, { params: where });
  }

  public exportAccountsPayable(where: any = {}, view?: string): Observable<Blob> {
    let path = 'api/reports/financial/accounts-payable';
    if (view === 'vendor') {
      path = 'api/reports/financial/accounts-payable/by-vendors';
    }
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    where.export = 1;
    return this.http.get(path, { params: where, responseType: 'blob' });
  }

  public communitiesPayable(where: any = {}, view?: string) {
    let path = 'api/reports/financial/communities-payable';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    return this.http.get(path, { params: where });
  }

  public exportCommunitiesPayable(where: any = {}, view?: string): Observable<Blob> {
    let path = 'api/reports/financial/communities-payable';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    where.export = 1;
    return this.http.get(path, { params: where, responseType: 'blob' });
  }

  public unBilledPayable(where: any = {}, view?: string) {
    let path = 'api/reports/financial/unbilled-payable';
    if (view === 'vendor') {
      path = 'api/reports/financial/unbilled-payable/by-vendors';
    }
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    return this.http.get(path, { params: where });
  }

  public exportUnBilledPayable(where: any = {}, view?: string): Observable<Blob> {
    let path = 'api/reports/financial/unbilled-payable';
    if (view === 'vendor') {
      path = 'api/reports/financial/unbilled-payable/by-vendors';
    }
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    where.export = 1;
    return this.http.get(path, { params: where, responseType: 'blob' });
  }

  public accountsReceivable(where: any = {}, view?: string) {
    let path = 'api/reports/financial/accounts-receivable';
    if (view === 'unit') {
      path = 'api/reports/financial/accounts-receivable/by-units';
    }
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    return this.http.get(path, { params: where });
  }

  public exportAccountsReceivable(where: any = {}, view?: string): Observable<Blob> {
    let path = 'api/reports/financial/accounts-receivable';
    if (view === 'unit') {
      path = 'api/reports/financial/accounts-receivable/by-units';
    }
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    where.export = 1;
    return this.http.get(path, { params: where, responseType: 'blob' });
  }

  public yearlyReceivables(where: any = {}) {
    let path = 'api/reports/financial/yearly-receivables';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    return this.http.get(path, { params: where });
  }

  public exportYearlyReceivables(where: any = {}): Observable<Blob> {
    let path = 'api/reports/financial/yearly-receivables';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    where.export = 1;
    return this.http.get(path, { params: where, responseType: 'blob' });
  }

  public communitiesReceivable(where: any = {}) {
    let path = 'api/reports/financial/communities-receivable';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    return this.http.get(path, { params: where });
  }

  public exportCommunitiesReceivable(where: any = {}): Observable<Blob> {
    let path = 'api/reports/financial/communities-receivable';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    where.export = 1;
    return this.http.get(path, { params: where, responseType: 'blob' });
  }

  public ownerUnitsReceivables(where: any = {}) {
    let path = 'api/reports/financial/owner-units-receivables';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    return this.http.get(path, { params: where });
  }

  public exportOwnerUnitsReceivables(where: any = {}): Observable<Blob> {
    let path = 'api/reports/financial/owner-units-receivables';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    where.export = 1;
    return this.http.get(path, { params: where, responseType: 'blob' });
  }

  public unitsSummary(where: any = {}) {
    let path = 'api/reports/financial/units-summary';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    return this.http.get(path, { params: where });
  }

  public exportUnitsSummary(where: any = {}): Observable<Blob> {
    let path = 'api/reports/financial/units-summary';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    where.export = 1;
    return this.http.get(path, { params: where, responseType: 'blob' });
  }

  public unitBalances(where: any = {}, page: number = 0, limit: number = 0) {
    let path = 'api/reports/financial/unit-balances';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    where.page = page;
    where.limit = limit;
    return this.http.get(path, { params: where });
  }

  public exportUnitBalances(where: any = {}, page: number = 0, limit: number = 0): Observable<Blob> {
    let path = 'api/reports/financial/unit-balances';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    where.page = page;
    where.limit = limit;
    where.export = 1;
    return this.http.get(path, { params: where, responseType: 'blob' });
  }

  public getUtilityBills(filter: any = {}, page: number = 0, limit: number = 0, where: any = {}) {
    const path = 'api/reports/financial/utitlity-bills';
    const params: any = {};

    Object.keys(where).forEach((key) => {
      params[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });

    if (filter.where) {
      params.where = JSON.stringify(filter.where);
    }
    if (filter.columns) {
      params.columns = JSON.stringify(filter.columns);
    }
    if (filter.include) {
      params.include = JSON.stringify(filter.include);
    }
    if (filter.count) {
      params.count = JSON.stringify(filter.count);
    }
    if (filter.orderBy) {
      params.order = JSON.stringify(filter.orderBy);
    }
    if (filter.utility_id) {
      params.utility_id = filter.utility_id;
    }
    if (filter.meter_no) {
      params.meter_no = filter.meter_no;
    }
    if (filter.total_amount) {
      params.total_amount = filter.total_amount;
    }
    if (page) {
      params.page = page;
    }
    if (limit) {
      params.limit = limit;
    }
    return this.http.get(path, { params: params });
  }

  public collectionReport(where: any = {}) {
    let path = 'api/reports/financial/collection-report';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    return this.http.get(path, { params: where });
  }

  public exportcollectionReportPdf(where: any = {}, svgContents: any): Observable<Blob> {
    let path = 'api/reports/financial/collection-report';
    where.exportPdf = 1;
    where.export = 0;
    const params = { ...where, svgPie: svgContents.svgPie, circleProgressSvg: svgContents.circleProgressSvg };
    Object.keys(params).forEach((key) => {
      params[key] = typeof params[key] === 'object' ? JSON.stringify(params[key]) : params[key];
    });

    return this.http.get(path, { params: params, responseType: 'blob' });
  }

  public exportcollectionReport(where: any = {}): Observable<Blob> {
    let path = 'api/reports/financial/collection-report';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    where.exportPdf = 0;
    where.export = 1;
    return this.http.get(path, { params: where, responseType: 'blob' });
  }

  public collectionReportYearly(params: any = {}) {
    let path = 'api/reports/financial/yearly-sc-collection-report';
    Object.keys(params).forEach((key) => {
      params[key] = typeof params[key] === 'object' ? JSON.stringify(params[key]) : params[key];
    });
    if (params.export) {
      return this.http.get(path, { params: params, responseType: 'blob' });
    }
    return this.http.get(path, { params: params });
  }

  public utilityExpenseReport(where: any = {}) {
    let path = 'api/reports/financial/utility-expense';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    return this.http.get(path, { params: where });
  }

  public utilityComparisonReport(where: any = {}): Observable<any | Blob> {
    let path = 'api/reports/financial/utility-comparison-report';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    if ('export' in where) {
      return this.http.get(path, { params: where, responseType: 'blob' });
    }
    return this.http.get(path, { params: where });
  }

  public banking(filter: any = null, extraWhere: any, tab: string = null, isExport: boolean = false) {
    const endPoint = 'api/reports/financial/banking';
    let params: any = {};
    params.filter = filter ? JSON.stringify(filter) : '{}';

    if (extraWhere.fromDate) {
      params.fromDate = extraWhere.fromDate;
    }

    if (extraWhere.toDate) {
      params.toDate = extraWhere.toDate;
    }

    if (extraWhere.accountType) {
      params.accountType = extraWhere.accountType;
    }

    if (tab) {
      params.tab = tab;
    }

    if (isExport) {
      params.export = 1;
      return this.http.get(endPoint, { params: params, responseType: 'blob' });
    } else {
      return this.http.get(endPoint, { params });
    }
  }

  public simplifiedFinancialHealth(where: any = {}) {
    let path = 'api/reports/financial/simplified-financial-health';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    return this.http.get(path, { params: where });
  }

  public exportSimplifiedFinancialHealth(where: any = {}): Observable<Blob> {
    let path = 'api/reports/financial/simplified-financial-health';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    where.export = 1;
    return this.http.get(path, { params: where, responseType: 'blob' });
  }

  public detailFinancialHealth(where: any = {}) {
    let path = 'api/reports/financial/detail-financial-health';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    return this.http.get(path, { params: where });
  }

  public exportDetailFinancialHealth(where: any = {}): Observable<Blob> {
    let path = 'api/reports/financial/detail-financial-health';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    where.export = 1;
    return this.http.get(path, { params: where, responseType: 'blob' });
  }

  public provisionsLedger(filter: any = null, where: any = {}, limit: number = 0, page: number = 1) {
    let endPoint = 'api/accounting/provisions/ledger';
    let params: any = {};
    params.filter = filter ? JSON.stringify(filter) : '{}';
    params.limit = limit;
    params.page = page;
    if (where.fromDate) {
      params.fromDate = where.fromDate;
    }
    if (where.toDate) {
      params.toDate = where.toDate;
    }
    return this.http.get(endPoint, { params: params });
  }

  public exportProvisionsLedger(filter: any = null, where: any = {}, limit: number = 0, page: number = 1): Observable<Blob> {
    let endPoint = 'api/accounting/provisions/ledger';
    let params: any = {};
    params.filter = filter ? JSON.stringify(filter) : '{}';
    params.limit = limit;
    params.page = page;
    params.export = 1;
    if (where.fromDate) {
      params.fromDate = where.fromDate;
    }
    if (where.toDate) {
      params.toDate = where.toDate;
    }
    return this.http.get(endPoint, { params: params, responseType: 'blob' });
  }

  public getCommunityGLByDate(where?: any, page: number = 0, limit: number = 0) {
    let endPoint = 'api/accounting/ledgers/community/gl/bydate';
    let params = this.setLedgerWhere(where);
    params.page = page;
    params.limit = limit;
    return this.http.get(endPoint, { params: params });
  }

  public exportCommunityGLByDate(where?: any, page: number = 0, limit: number = 0): Observable<Blob> {
    let endPoint = 'api/accounting/ledgers/community/gl/bydate';
    let params = this.setLedgerWhere(where);
    params.page = page;
    params.limit = limit;
    params.export = 1;
    return this.http.get(endPoint, { params: params, responseType: 'blob' });
  }

  public getCommunityGLByAccount(id: any, where?: any, page: number = 0, limit: number = 0) {
    let endPoint = 'api/accounting/ledgers/community/gl/byaccount/' + id;
    let params = this.setLedgerWhere(where);
    params.page = page;
    params.limit = limit;
    return this.http.get(endPoint, { params: params });
  }

  public exportCommunityGLByAccount(id: any, where?: any, page: number = 0, limit: number = 0): Observable<Blob> {
    let endPoint = 'api/accounting/ledgers/community/gl/byaccount/' + id;
    let params = this.setLedgerWhere(where);
    params.page = page;
    params.limit = limit;
    params.export = 1;
    return this.http.get(endPoint, { params: params, responseType: 'blob' });
  }

  public unitsAging(where: any = {}) {
    const path = 'api/reports/portfolio/financial/units-aging';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    where.edges = 7;
    return this.http.get(path, { params: where });
  }

  public exportUnitsAging(where: any): Observable<Blob> {
    let path = 'api/reports/portfolio/financial/units-aging';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    where.edges = 13;
    where.export = 1;
    return this.http.get(path, { params: where, responseType: 'blob' });
  }

  public unitsAgingV2(where: any = {}) {
    const path = 'api/reports/portfolio/financial/units-aging-v2-v3';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    where.edges = 7;
    return this.http.get(path, { params: where });
  }

  public exportUnitsAgingV2(where: any): Observable<Blob> {
    let path = 'api/reports/portfolio/financial/units-aging-v2-v3';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    where.edges = 13;
    where.export = 1;
    return this.http.get(path, { params: where, responseType: 'blob' });
  }

  public unitsAgingYearly(where: any = {}) {
    const path = 'api/reports/portfolio/financial/units-aging-yearly';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    where.edges = 7;
    return this.http.get(path, { params: where });
  }

  public exportUnitsAgingYearly(where: any): Observable<Blob> {
    let path = 'api/reports/portfolio/financial/units-aging-yearly';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    where.edges = 13;
    where.export = 1;
    return this.http.get(path, { params: where, responseType: 'blob' });
  }

  public unitsAgingYearlyV2(where: any = {}) {
    const path = 'api/reports/portfolio/financial/units-aging-yearly-v2';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    where.edges = 7;
    return this.http.get(path, { params: where });
  }

  public exportUnitsAgingYearlyV2(where: any): Observable<Blob> {
    let path = 'api/reports/portfolio/financial/units-aging-yearly-v2';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    where.edges = 13;
    where.export = 1;
    return this.http.get(path, { params: where, responseType: 'blob' });
  }

  public vendorsAging(where: any = {}) {
    let path = 'api/reports/portfolio/financial/vendors-aging';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    return this.http.get(path, { params: where });
  }

  public exportVendorsAging(where: any): Observable<Blob> {
    let path = 'api/reports/portfolio/financial/vendors-aging';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    where.export = 1;
    return this.http.get(path, { params: where, responseType: 'blob' });
  }

  getCommunityWiseVendorsAgingReport(where: any = {}): any | Observable<Blob> {
    let path = 'api/reports/portfolio/financial/vendors-aging-community';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    if ('export' in where) {
      return this.http.get(path, { params: where, responseType: 'blob' });
    }

    return this.http.get(path, { params: where });
  }

  public vendorsAgingV2(where: any = {}) {
    const path = 'api/reports/portfolio/financial/vendors-aging-v2';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    return this.http.get(path, { params: where });
  }

  public exportVendorsAgingV2(where: any): Observable<Blob> {
    let path = 'api/reports/portfolio/financial/vendors-aging-v2';
    Object.keys(where).forEach((key) => {
      where[key] = typeof where[key] === 'object' ? JSON.stringify(where[key]) : where[key];
    });
    where.export = 1;
    return this.http.get(path, { params: where, responseType: 'blob' });
  }

  public convenienceFee(filter: any, page: number, limit: number): Observable<any> {
    const path = 'api/reports/financial/convenience-fee';
    filter.page = page;
    filter.limit = limit;
    return this.http.get(path, { params: filter });
  }

  public exportConvenienceFee(filter: any, page: number, limit: number): Observable<Blob> {
    const path = 'api/reports/financial/convenience-fee-export';
    filter.page = page;
    filter.limit = limit;
    return this.http.get(path, { params: filter, responseType: 'blob' });
  }

  private setLedgerWhere(where: any) {
    let params: any = {};
    if (!where) {
      return params;
    }
    if (where.association_id) {
      params.association_id = where.association_id;
    }
    if (where.account_id) {
      params.account_id = where.account_id;
    }
    if (where.accountIds) {
      params.accountIds = JSON.stringify(where.accountIds);
    }
    if (where.associationIds) {
      params.associationIds = JSON.stringify(where.associationIds);
    }
    if (where.fromDate) {
      params.fromDate = where.fromDate;
    }
    if (where.toDate) {
      params.toDate = where.toDate;
    }
    if (where.type) {
      params.type = where.type;
    }
    if (where.transactionable) {
      params.transactionable = where.transactionable;
    }
    if (where.ledgerIds) {
      params.ledgerIds = JSON.stringify(where.ledgerIds);
    }
    if (where.export) {
      params.export = where.export;
    }
    if (where.email_to) {
      params.email_to = where.email_to;
    }
    if (where.books) {
      params.books = where.books;
    }
    if (where.trx_number) {
      params = {};
      params.trx_number = where.trx_number;
    }
    return params;
  }
}
